import React, { Component } from 'react';

import { LegacyClubRedirectAlert } from 'components/legacyClubRedirectAlert';
import { NewClubMigrationModal } from 'components/newClubMigrationModal';
import { OfferToast } from 'components/offerToast';
import { I18n, translate } from 'components/translate';
import { inject, PropTypes as MobxPropTypes } from 'mobx-react';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import ContentBasePage from 'modules/content/components/ContentBasePage';
import { SalesService } from 'modules/salesManager';
import PropTypes from 'prop-types';

import { LinkedCards } from './linkedCards';
import { MarketingBanner } from './marketingBanner';
import ClubSalesNavigationCard from './navigationCard/ClubSalesNavigationCard';
import PlusAccessNavigationCard from './navigationCard/PlusAccessNavigationCard';
import { UserReports } from './userReports';

import DashboardMembershipBanner from '../../../membershipBanner/DashboardMembershipBanner';
import { BANNERS, CURRENT_BANNER } from '../constants';
import DashboardService from '../DashboardService';

import './Dashboard.scss';

class Dashboard extends Component {
  static propTypes = {
    t: PropTypes.func,
    name: PropTypes.string,
    shortLocale: PropTypes.string,
    marketplaceId: PropTypes.number,
    userData: MobxPropTypes.objectOrObservableObject,
    showableOfferAlert: PropTypes.bool,
    shouldShowMembershipBanner: PropTypes.bool
  };

  componentDidMount() {
    DashboardService.fetchUserData();
    this.sendEventWhenUserIsRedirected();
  }

  handleAlertClose = SalesService.sendDashboardOfferEvent;

  sendEventWhenUserIsRedirected() {
    const { productId, userId } = this.props;
    const REDIRECTED_USER_ORIGIN = 'REDIRECTED_USER';
    const searchParams = new URLSearchParams(document.location.search);
    const isRedirectedUser =
      searchParams.get('origin') === REDIRECTED_USER_ORIGIN;

    if (isRedirectedUser) {
      DatahubService.sendEvent({
        action: 'redirect',
        event: {
          productId,
          userId
        }
      });
    }
  }

  renderBanner() {
    const { marketplaceId } = this.props;

    return {
      [BANNERS.MARKETING_BANNER]: () => (
        <MarketingBanner marketplaceId={marketplaceId} />
      ),
      [BANNERS.CLUB_SALES_PLUS_ACCESS]: () => (
        <>
          <h3 className="members-area-title">
            <I18n label="dashboard.members_area" />
          </h3>
          <section className="navigation-cards dashboard__item">
            <ClubSalesNavigationCard />
            <PlusAccessNavigationCard />
          </section>
        </>
      )
    }[CURRENT_BANNER]?.();
  }

  render() {
    const {
      t,
      name,
      userData,
      marketplaceId,
      shortLocale,
      showableOfferAlert,
      shouldShowMembershipBanner
    } = this.props;

    return (
      <ContentBasePage className="dashboard__grid">
        <h1 className="_text-gray-900 _text-6 _mb-6">
          {t('dashboard.hello', { data: { name } })}
        </h1>

        <LegacyClubRedirectAlert />

        {shouldShowMembershipBanner && <DashboardMembershipBanner />}

        <div className="dashboard__container _mt-6">
          <UserReports marketplaceId={marketplaceId} userData={userData} />
          {this.renderBanner()}
          <LinkedCards
            marketplaceId={marketplaceId}
            shortLocale={shortLocale}
          />
        </div>

        {showableOfferAlert && (
          <OfferToast.Dashboard onClose={this.handleAlertClose} />
        )}
        <NewClubMigrationModal />
      </ContentBasePage>
    );
  }
}

export default translate()(
  inject((stores) => ({
    name: stores.UserStore.name,
    marketplaceId: stores.UserStore.marketplaceId,
    userData: stores.DashboardStore.user,
    shortLocale: stores.UserStore.shortLocale,
    showableOfferAlert: stores.SalesStore.showableDashboardOfferAlert,
    shouldShowMembershipBanner: stores.UserStore.shouldShowMembershipBanner,
    productId: stores.MembershipStore.productId,
    userId: stores.UserStore.marketplaceId
  }))(Dashboard)
);

export { Dashboard };
